import React from "react"
import { getDefaultExpandedOptions } from "../../../converters/filters"
import CheckboxFilterCategory from "../CheckboxFilterCategory"
import CheckboxTreeFilter from "../CheckboxTreeFilter"
import PercentFilterItem from "../PercentFilterItem"
import RangeFilterItem from "../RangeFilterItem"
import { CheckboxFilterOption, FilterCategory } from "../types"

interface Props {
  item: FilterCategory
  parent?: CheckboxFilterOption
  onItemUpdate: (item: FilterCategory) => void
  onOptionExpand?: (item: CheckboxFilterOption) => void
  className?: string
  maxScrollItems?: number
  minTextFilterItems?: number
  useTreeFilters?: boolean
}

const FilterCategoryContent = ({
  item,
  parent,
  onItemUpdate,
  onOptionExpand,
  className,
  maxScrollItems,
  minTextFilterItems,
  useTreeFilters,
}: Props) => {
  if (useTreeFilters && item.id === "category") {
    return (
      <CheckboxTreeFilter
        className={className}
        item={item}
        onItemUpdate={onItemUpdate}
        maxScrollItems={maxScrollItems}
        defaultExpandedOptions={getDefaultExpandedOptions(item.options)}
      />
    )
  }
  switch (item.type) {
    case "checkbox":
      return (
        <CheckboxFilterCategory
          className={className}
          item={item}
          parent={parent}
          onItemUpdate={onItemUpdate}
          onOptionExpand={onOptionExpand}
          maxScrollItems={maxScrollItems}
          minTextFilterItems={minTextFilterItems}
        />
      )
    case "percent":
      return (
        <PercentFilterItem
          className={className}
          item={item}
          onItemUpdate={onItemUpdate}
        />
      )
    default:
      return (
        <RangeFilterItem
          className={className}
          item={item}
          onItemUpdate={onItemUpdate}
        />
      )
  }
}

export default FilterCategoryContent
